import { Routes } from '@angular/router';
import { authGuard, esicAdminGuard, esicCidadaoGuard, ouvidoriaAdminGuard, ouvidoriaCidadaoGuard } from '@core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@features/landing/landing.component').then(m => m.LandingComponent),
    pathMatch: 'full'
  },
  {
    path: 'modulo/esic/login/:idtenancy',
    loadComponent: () => import('@features/acesso/pages/login-esic/login-esic.component').then(m => m.LoginEsicComponent),
  },
  {
    path: 'modulo/esic/login',
    loadComponent: () => import('@features/acesso/pages/login-esic/login-esic.component').then(m => m.LoginEsicComponent),
  },
  {
    // URL do legado: /modulo/esic/cadastrousuariopf/:idtenancy
    path: 'modulo/esic/cadastrousuariopf/:idtenancy',
    loadComponent: () => import('@features/acesso/pages/cadastro-esic-pessoa-fisica/cadastro-esic-pessoa-fisica.component').then(m => m.CadastroEsicPessoaFisicaComponent),
  },
  {
    path: 'modulo/esic/cadastrousuariopf',
    loadComponent: () => import('@features/acesso/pages/cadastro-esic-pessoa-fisica/cadastro-esic-pessoa-fisica.component').then(m => m.CadastroEsicPessoaFisicaComponent),
  },
  {
    // Estatísticas públicas do e-SIC da entidade: aberta pelo link da tela de login, antes de
    // qualquer autenticação. A entidade vem no caminho porque ainda não há sessão de onde tirá-la.
    path: 'modulo/esic/estatisticas/:idtenancy',
    loadComponent: () => import('@features/esic/pages/estatisticas/esic-estatisticas.component').then(m => m.EsicEstatisticasComponent),
  },
  {
    // Prazos de atendimento da entidade, pelo mesmo caminho das estatísticas: link da tela de
    // login, entidade no caminho, sem autenticação.
    path: 'modulo/esic/prazos/:idtenancy',
    loadComponent: () => import('@features/esic/pages/prazos/esic-prazos.component').then(m => m.EsicPrazosComponent),
  },
  {
    // URL do legado: /modulo/esic/cadastrousuariopj/:idtenancy
    path: 'modulo/esic/cadastrousuariopj/:idtenancy',
    loadComponent: () => import('@features/acesso/pages/cadastro-esic-pessoa-juridica/cadastro-esic-pessoa-juridica.component').then(m => m.CadastroEsicPessoaJuridicaComponent),
  },
  {
    path: 'modulo/esic/cadastrousuariopj',
    loadComponent: () => import('@features/acesso/pages/cadastro-esic-pessoa-juridica/cadastro-esic-pessoa-juridica.component').then(m => m.CadastroEsicPessoaJuridicaComponent),
  },
  {
    path: 'modulo/ouvidoria/login/:idtenancy',
    loadComponent: () => import('@features/acesso/pages/login-ouvidoria/login-ouvidoria.component').then(m => m.LoginOuvidoriaComponent),
  },
  {
    path: 'modulo/ouvidoria/login',
    loadComponent: () => import('@features/acesso/pages/login-ouvidoria/login-ouvidoria.component').then(m => m.LoginOuvidoriaComponent),
  },
  {
    path: 'modulo/ouvidoria/manifestacao/anonima/:idtenancy',
    loadComponent: () => import('@features/ouvidoria/pages/manifestacao-anonima/manifestacao-anonima.component').then(m => m.ManifestacaoAnonimaComponent),
  },
  {
    // Sem a entidade na URL a tela cai no contexto em cache (quem veio do login já o tem).
    path: 'modulo/ouvidoria/manifestacao/anonima',
    loadComponent: () => import('@features/ouvidoria/pages/manifestacao-anonima/manifestacao-anonima.component').then(m => m.ManifestacaoAnonimaComponent),
  },
  {
    // URL do legado: /modulo/ouvidoria/cadastrousuariopf/:idtenancy
    path: 'modulo/ouvidoria/cadastrousuariopf/:idtenancy',
    loadComponent: () => import('@features/acesso/pages/cadastro-pessoa-fisica/cadastro-pessoa-fisica.component').then(m => m.CadastroPessoaFisicaComponent),
  },
  {
    // Sem a entidade na URL a tela cai no contexto em cache (quem veio do login já o tem).
    path: 'modulo/ouvidoria/cadastrousuariopf',
    loadComponent: () => import('@features/acesso/pages/cadastro-pessoa-fisica/cadastro-pessoa-fisica.component').then(m => m.CadastroPessoaFisicaComponent),
  },
  {
    // URL do legado: /modulo/ouvidoria/cadastrousuariopj/:idtenancy
    path: 'modulo/ouvidoria/cadastrousuariopj/:idtenancy',
    loadComponent: () => import('@features/acesso/pages/cadastro-pessoa-juridica/cadastro-pessoa-juridica.component').then(m => m.CadastroPessoaJuridicaComponent),
  },
  {
    // Sem a entidade na URL a tela cai no contexto em cache (quem veio do login já o tem).
    path: 'modulo/ouvidoria/cadastrousuariopj',
    loadComponent: () => import('@features/acesso/pages/cadastro-pessoa-juridica/cadastro-pessoa-juridica.component').then(m => m.CadastroPessoaJuridicaComponent),
  },
  {
    // Tudo sob o shell autenticado: as telas públicas (login, autocadastro, manifestação
    // anônima) estão declaradas acima, fora deste ramo. Sem o guard, uma sessão expirada
    // abria a tela normalmente e só falhava com 401 na hora de gravar.
    path: 'modulo',
    canActivate: [authGuard],
    // Papéis por prefixo de URL: operador em /modulo/{esic,ouvidoria}/admin/**, qualquer papel
    // do módulo em /modulo/{esic,ouvidoria}/cidadao/** — cada guard ignora as demais filhas.
    canActivateChild: [esicAdminGuard, esicCidadaoGuard, ouvidoriaAdminGuard, ouvidoriaCidadaoGuard],
    loadComponent: () => import('@layout/layout.component').then(m => m.LayoutComponent),
    children: [
      {
        path: '',
        loadChildren: () => import('@features/esic/esic.routes').then(m => m.esicRoutes),
      },
      {
        path: '',
        loadChildren: () => import('@features/ouvidoria/ouvidoria.routes').then(m => m.ouvidoriaRoutes),
      },
      {
        path: '',
        loadChildren: () => import('@features/conta/conta.routes').then(m => m.contaRoutes),
      },
    ]
  }
];
